<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const OptionsIcon = getIcon("OptionsIcon");
</script>

{#if typeof OptionsIcon === 'string'}
	<img src={OptionsIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof OptionsIcon === 'function'}
	<svelte:component this={OptionsIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
